import React, { useState } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import withConfirm from 'hooks/withConfirm';
import useSnack from 'hooks/useSnack';
import { ROLES } from '../../../../constant/userTypes';
import ProgramEndModal from 'modules/student/timeline/components/ProgramEndModal';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiSelect-iconOutlined': {
      color: 'inherit',
      right: 4,
      top: 'calc(50% - 13px)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
  },
  select: {
    paddingTop: 6,
    paddingBottom: 6,
    fontSize: '14px',
    fontWeight: 700,
  },
  item: {
    fontSize: 'inherit',
  },
}));

const options = [
  {
    text: 'In Progress',
    value: 'new',
  },
  {
    text: 'Draft',
    value: 'draft',
  },
  {
    text: 'CC Review',
    value: 'cc_review',
  },
  {
    text: 'HC Review',
    value: 'hc_review',
  },
  {
    text: 'Done',
    value: 'done',
  },
];

const soloOptions = [
  {
    text: 'In Progress',
    value: 'new',
  },
  {
    text: 'Draft',
    value: 'draft',
  },
  {
    text: 'Expert Review',
    value: 'expert_review',
  },
  {
    text: 'Done',
    value: 'done',
  },
];

const cohortOptions = [
  {
    text: 'In Progress',
    value: 'new',
  },
  {
    text: 'Draft',
    value: 'draft',
  },
  {
    text: 'Expert Review',
    value: 'expert_review',
  },
  {
    text: 'Done',
    value: 'done',
  },
];

const css = (value) => {
  switch (value) {
    case 'done':
      return {
        marginTop: 0,
        backgroundColor: '#F5FCF0',
        borderColor: '#F5FCF0',
        borderRadius: '4px',
        color: '#87CF50',
      };

    case 'cc_review':
      return {
        marginTop: 0,
        backgroundColor: '#F2F5FE',
        borderColor: '#F2F5FE',
        borderRadius: '4px',
        color: '#547FF6',
      };
    case 'expert_review':
      return {
        marginTop: 0,
        backgroundColor: '#D5ECFF',
        borderColor: '#D5ECFF',
        borderRadius: '4px',
        color: '#5AB1F9',
      };
    case 'hc_review':
      return {
        marginTop: 0,
        backgroundColor: '#F2F5FE',
        borderColor: '#F2F5FE',
        borderRadius: '4px',
        color: '#547FF6',
      };
    case 'draft':
      return {
        marginTop: 0,
        backgroundColor: '#F8F0FF',
        borderColor: '#F8F0FF',
        borderRadius: '4px',
        color: '#AF22AA',
      };

    case 'new':
      return {
        marginTop: 0,
        backgroundColor: '#F0F0F0',
        borderColor: '#F0F0F0',
        borderRadius: '4px',
        color: '#696D75',
      };

    default:
      return {};
      break;
  }
};

const Status = ({
  id,
  value,
  onChangeStatus,
  student,
  confirm,
  hasHCCredit,
  hasCCCredit,
  readOnly,
  doc,
  hasExpertCredit,
  profile,
  user
}) => {
  const classes = useStyles();
  const color = css(value);
  const { product_type } = student;
  const snack = useSnack();
  const isSolo = product_type === 'solo';
  const isCohort = product_type === 'cohort';
  const coachesAction = user.type === ROLES.HC || user.type === ROLES.LC || user.type === ROLES.ADMIN || user.type === ROLES.PARENT || user.type === ROLES.FA;
  const [isProgramEndModal, setIsProgramEndModal] = useState(false)



  const onChange = (e) => {
    const { value: status } = e.target;
    if (status === value) return;
    if (status === 'cc_review') {
      if (coachesAction || profile?.subscriptions[0]?.status === 'active') {
        if (!hasCCCredit) {
          snack.error('No CC Essay credit available');
        } else {
          const confirmProps =
            product_type === 'pro'
              ? {
                description:
                  'Are you sure your essay is ready to be reviewed by your College Coach? Double-check that you’ve made all the necessary revisions. Your CC’s time is valuable, so you want to be sure you are using their time wisely!',
              }
              : {
                title: 'Would you like to use a CC essay review credit?',
                description: `Are you sure your essay is ready to be reviewed by your College Coach? Double-check that you’ve made all the necessary revisions. This will count as a CC revision credit. Your CC’s time is valuable, so you want to be sure you are using their time wisely!`,
              };
          confirm(() => {
            onChangeStatus({ id, status, doc });
          }, confirmProps);
        }
      }
      else {
        setIsProgramEndModal(true)
      }
    }

    else if (status === 'hc_review') {
      if (coachesAction || profile?.subscriptions[0]?.status === 'active') {
        if (!hasHCCredit) {
          snack.error('No HC Essay credit available');
        } else {
          const confirmProps =
            product_type === 'pro'
              ? {
                description:
                  'Are you sure your essay is ready to be reviewed by your Head Counselor? Double-check that you’ve made all the necessary revisions. Your HC’s time is valuable, so you want to be sure you are using their time wisely!',
              }
              : {
                title: 'Would you like to use a HC essay review credit?',
                description:
                  'Are you sure your essay is ready to be reviewed by your Head Counselor? Double-check that you’ve made all the necessary revisions. This will count as an HC revision credit. Your HC’s time is valuable, so you want to be sure you are using their time wisely!',
              };
          confirm(() => {
            onChangeStatus({ id, status, doc });
          }, confirmProps);
        }
      }
      else {
        setIsProgramEndModal(true)
      }
    }

    else if (status === 'expert_review') {
      if (!hasExpertCredit) {
        snack.error('No Expert credit available');
      } else {
        const confirmProps = {
          title: 'Would you like to use an Expert review credit?',
          description:
            'Double-check that you’ve made all the necessary revisions. This will count as an Expert Review credit.',
        };
        confirm(() => {
          onChangeStatus({ id, status, doc });
        }, confirmProps);
      }
    }
    else if (status === 'done') {
      (isSolo || isCohort)
        ? onChangeStatus({ id, status, doc })
        : confirm(
          () => {
            onChangeStatus({ id, status, doc });
          },
          {
            title: `Are you sure? Only mark an essay as “Done” if you do not require any additional revisions from your counseling team.`,
          },
        );
    } else {
      (isSolo || isCohort)
        ? onChangeStatus({ id, status, doc })
        : confirm(() => {
          onChangeStatus({ id, status, doc });
        });
    }
  };

  return (
    <FormControl
      size="small"
      variant="outlined"
      classes={{ root: classes.root }}
    >
      <Select
        disabled={readOnly}
        disableUnderline
        classes={{
          select: classes.select,
        }}
        style={{
          backgroundColor: color.backgroundColor,
          color: color.color,
          borderRadius: 6,
        }}
        value={value}
        onChange={onChange}
      >
        {!isSolo && !isCohort &&
          options.map((i) => (
            <MenuItem
              classes={{ root: classes.item }}
              key={i.value}
              value={i.value}
            >
              {i.text}
            </MenuItem>
          ))}
        {isSolo &&
          soloOptions.map((i) => (
            <MenuItem
              classes={{ root: classes.item }}
              key={i.value}
              value={i.value}
            >
              {i.text}
            </MenuItem>
          ))}
        {isCohort &&
          cohortOptions.map((i) => (
            <MenuItem
              classes={{ root: classes.item }}
              key={i.value}
              value={i.value}
            >
              {i.text}
            </MenuItem>
          ))}
      </Select>
      {isProgramEndModal &&

        <ProgramEndModal setShowModal={setIsProgramEndModal} student={profile} />
      }
    </FormControl>
  );
};

export default withConfirm(Status);
